import React from 'react'

import { useFormatCurrency } from '@src/hooks/useFormatCurrency'

import {
  MenuItemName,
  MenuItemPrice,
  MenuItemQuantity,
  MenuItemsContainer,
  MenuItemTable,
  OptionItemSubContainer,
  OptionItemName,
  OptionItemPrice,
  OptionItemsContainer,
  OptionItemSpacer,
  StyledBasketSVG,
} from './MenuItems.styles'

import { singleOrderCustomType } from '../queries/getSingleOrderCustomType'
import { useTheme } from 'styled-components'

export const MenuItems: React.FC<{ myOrder: singleOrderCustomType }> = ({
  myOrder,
}) => {
  const formatCurrency = useFormatCurrency()
  const theme = useTheme()
  return (
    <MenuItemTable>
      {myOrder.groupedItems.map(groupedItem => (
        <React.Fragment key={groupedItem.id}>
          <MenuItemsContainer>
            <MenuItemName>{groupedItem.name}</MenuItemName>
            <MenuItemQuantity>
              {groupedItem.quantity}
              {'x'}
            </MenuItemQuantity>
            <MenuItemPrice>
              {groupedItem.isAddOnItem && (
                <StyledBasketSVG fill={theme.colors.brand} id="offer-item" />
              )}
              {formatCurrency(groupedItem.totalPrice)}
            </MenuItemPrice>
          </MenuItemsContainer>
          {groupedItem.singleItemNotes && (
            <OptionItemSubContainer>
              <OptionItemName>{groupedItem.singleItemNotes}</OptionItemName>
              <OptionItemSpacer />
              <OptionItemPrice />
            </OptionItemSubContainer>
          )}
          <OptionItemsContainer>
            {groupedItem?.optionItems?.map(optionItem => (
              <OptionItemSubContainer key={`${groupedItem.id}${optionItem.id}`}>
                <OptionItemName>
                  {'\u2022'} {optionItem.name}
                </OptionItemName>
                <OptionItemSpacer />
                <OptionItemPrice>
                  {!!optionItem.price && formatCurrency(optionItem.price)}
                </OptionItemPrice>
              </OptionItemSubContainer>
            ))}
          </OptionItemsContainer>
        </React.Fragment>
      ))}
    </MenuItemTable>
  )
}
